import Utils from '../../../utils'
import 'firebase/compat/firestore'

export const sendMessageApiCall = (values, setSubmitting, refetch) => {
    Utils.api.postApiCall(
        `chats/firestore/order-rooms/detail/${values?.order_id}/send-message/${values?.vendor_id}/`,
        values,
        () => {
            // ✅ Success toast removed - modal closes when message is detected via Firebase
            setSubmitting(false)
            // ✅ Defer modal close - let Formik update flush
            Promise.resolve().then(() => {
                refetch()  // handleClose
            })
        },
        (error) => {
            const { data } = error
            Utils.showAlert(2, data.message || data?.non_field_errors?.[0] || 'Something went wrong')
            setSubmitting(false)
        }
    )
}
